import { Component, HostBinding, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NmAlertIcons } from './icons.interface';

let NEXT_ID = 0;

@Component({
    animations: [
        trigger('animate', [
            state('show', style({
                opacity: 1
            })),
            transition('* => show', animate('.20s ease')),
            transition('show => *', animate('.40s ease-out'))
        ])
    ],
    selector: 'nm-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss']
})
export class NmAlertComponent implements OnInit {

    /*
     * ç»ä»¶ id
     *
     */
    @HostBinding('attr.id')
    @Input()
    public id = `nm-alert-${NEXT_ID++}`;

    /*
     * Alert ç¶æ (successãinfoãwarningãerror)
     */
    @Input()
    public status: string;

    /*
     * æ¯å¦å¯ä»¥æå¨å³é­ Alert, é»è®¤ä¸º true
     */
    @Input()
    public dismissible: boolean;

    /**
     * æ¯å¦æ¾ç¤ºå¾æ , é»è®¤ä¸º true
     */
    @Input()
    public hasIcon: boolean;

    /**
     * Alert æ¯å¦å¯è§
     */
    @Input()
    public isVisible: boolean;

    /**
     * Alert å¯éå¾æ 
     */
    @Input()
    public set icon(value: NmAlertIcons) {
        this.icons = Object.assign(this.icons, {
            [this.status]: value
        });
    }

    /**
     * Alert æ¾ç¤ºåºæ¥æ¶è§¦åçäºä»¶
     *
     * @memberOf NmAlertComponent
     */
    @Output()
    public shown = new EventEmitter<NmAlertComponent>();

    /**
     * Alert éèæ¶è§¦åçäºä»¶
     *
     * @memberOf NmAlertComponent
     */
    @Output()
    public hidden = new EventEmitter<NmAlertComponent>();

    public icons: NmAlertIcons;

    constructor() {
        this.status = 'info';
        this.dismissible = true;
        this.hasIcon = true;
        this.icons = {
            success: 'check_circle',
            info: 'info',
            warning: 'warning',
            error: 'error'
        };
        this.isVisible = false;
    }

    ngOnInit() {
    }

    /**
     * æ¾ç¤º Alert
     */
    public show() {
        this.isVisible = true;
        this.shown.emit(this);
    }

    /**
     * éè Alert
     */
    public hide() {
        this.isVisible = false;
        this.hidden.emit(this);
    }

    /**
     * åæ¢ Alert çå¯è§ç¶æ
     */
    public toggle() {
        this.isVisible ? this.hide() : this.show();
    }
}
